import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface FieldProps {
  label: React.ReactNode;
  /** secondary explanatory line under the label */
  hint?: React.ReactNode;
  /** if set, shows an info icon next to the label with this tooltip */
  info?: React.ReactNode;
  children: React.ReactNode;
}

/** A single label-left / control-right settings row. */
const Field: React.FC<FieldProps> = ({ label, hint, info, children }) => (
  <div className="set-studio__field">
    <div className="set-studio__field-label">
      <span className="set-studio__field-name">
        {label}
        {info ? (
          <Tooltip title={info}>
            <InfoCircleOutlined className="set-studio__field-info" />
          </Tooltip>
        ) : null}
      </span>
      {hint ? <span className="set-studio__field-hint">{hint}</span> : null}
    </div>
    <div className="set-studio__field-control">{children}</div>
  </div>
);

export default Field;
